import React, { useContext } from 'react';
import LoginHeader from '../../components/Headers/LoginHeader';
import LoginFooter from '../../components/Footers/LoginFooter';
import PurchaseSingle from '../../components/PurchaseSingle';
import { UserContext } from '../../context/User';
import AdminHeader from '../../components/Headers/AdminHeader';

const PurchaseSinglePage = () => {
  const { user } = useContext(UserContext);
  const role = user && user.roles && user.roles[0].role_description;

  return (
    <>  
      {role === "admin" ? <AdminHeader /> : <LoginHeader />}
      <main>
        <PurchaseSingle />
      </main>
      <LoginFooter />
    </>
  )
}

export default PurchaseSinglePage;